
const digest = '92f3dfdd1b805f6607c4495daba3445247d6b42850d08d80c4a5ed10ccc5daa5';
const classes = {"wrapper":"_wrapper_q2u0a_1","header":"_header_q2u0a_10","date":"_date_q2u0a_22","medicament":"_medicament_q2u0a_26","validityDate":"_validityDate_q2u0a_30","options":"_options_q2u0a_36","list":"_list_q2u0a_45","item":"_item_q2u0a_73","patient":"_patient_q2u0a_80","patientImage":"_patientImage_q2u0a_86","patientData":"_patientData_q2u0a_91","title":"_title_q2u0a_91","text":"_text_q2u0a_97","contentWrapper":"_contentWrapper_q2u0a_103","content":"_content_q2u0a_103","medicamentWrapper":"_medicamentWrapper_q2u0a_118","dose":"_dose_q2u0a_129","contentSukl":"_contentSUKL_q2u0a_134","moreInfo":"_moreInfo_q2u0a_137","moreInfoItem":"_moreInfoItem_q2u0a_144","controls":"_controls_q2u0a_156","link":"_link_q2u0a_167"};
const css = `._wrapper_q2u0a_1 {
  font-family: Rubik, "sans-serif";
  background: #ffffff;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
}
._wrapper_q2u0a_1 ._header_q2u0a_10 {
  display: flex;
  flex-direction: row;
  gap: 28px;
  padding: 6px 19px;
  font-size: 14px;
  font-weight: 500;
  background: #fbfbfd !important;
  border-right: 1px solid #eaedf3;
  border-left: 1px solid #eaedf3;
  border-bottom: 1px solid #eaedf3;
}
._wrapper_q2u0a_1 ._header_q2u0a_10 ._date_q2u0a_22 {
  min-width: 130px;
  max-width: 130px;
}
._wrapper_q2u0a_1 ._header_q2u0a_10 ._medicament_q2u0a_26 {
  flex-grow: 1;
  padding-left: 24px;
}
._wrapper_q2u0a_1 ._header_q2u0a_10 ._validityDate_q2u0a_30 {
  min-width: 200px;
  max-width: 200px;
  margin-right: 200px;
  padding: 0 8px;
}
._wrapper_q2u0a_1 ._options_q2u0a_36 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._wrapper_q2u0a_1 ._list_q2u0a_45::-webkit-scrollbar {
  display: block;
}
._wrapper_q2u0a_1 ._list_q2u0a_45::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_q2u0a_1 ._list_q2u0a_45::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_q2u0a_1 ._list_q2u0a_45::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_q2u0a_1 ._list_q2u0a_45::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 {
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._patient_q2u0a_80 {
  display: flex;
  border-right: 1px solid #eaedf3;
  padding: 24px;
  gap: 16px;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._patient_q2u0a_80 ._patientImage_q2u0a_86 {
  width: 36px;
  height: 36px;
  border-radius: 100%;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._patient_q2u0a_80 ._patientData_q2u0a_91 ._title_q2u0a_91 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
  color: #000000;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._patient_q2u0a_80 ._patientData_q2u0a_91 ._text_q2u0a_97 {
  color: #9ea0a5;
  font-size: 14px;
  min-width: 130px;
  max-width: 130px;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._contentWrapper_q2u0a_103 {
  width: 100%;
  display: flex;
  flex-direction: row;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._content_q2u0a_103 {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  gap: 20px;
  font-size: 16px;
  color: #000000;
  padding: 24px;
  justify-content: space-between;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._content_q2u0a_103 ._medicamentWrapper_q2u0a_118 {
  gap: 20px;
  display: flex;
  justify-content: space-between;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._content_q2u0a_103 ._medicamentWrapper_q2u0a_118 ._medicament_q2u0a_26 {
  font-weight: 500;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._content_q2u0a_103 ._medicamentWrapper_q2u0a_118 ._medicament_q2u0a_26 span {
  font-weight: 400;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._content_q2u0a_103 ._medicamentWrapper_q2u0a_118 ._dose_q2u0a_129 {
  display: flex;
  justify-content: center;
  min-width: 50px;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._contentSUKL_q2u0a_134 {
  flex-direction: column;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._moreInfo_q2u0a_137 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._moreInfo_q2u0a_137 ._moreInfoItem_q2u0a_144 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._moreInfo_q2u0a_137 ._moreInfoItem_q2u0a_144 ._title_q2u0a_91 {
  color: grey;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._moreInfo_q2u0a_137 ._moreInfoItem_q2u0a_144 ._text_q2u0a_97 {
  color: #000000;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._controls_q2u0a_156 {
  min-width: 200px;
  max-width: 200px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 16px;
}
._wrapper_q2u0a_1 ._list_q2u0a_45 ._item_q2u0a_73 ._controls_q2u0a_156 ._link_q2u0a_167 {
  font-size: 14px;
  font-weight: 500;
  color: #1665d8;
  text-decoration: underline;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  